import type { ReactNode } from "react";

/**
 * Empty is usually a question, not an answer: "no rows" and "nothing is
 * running" look identical. Every one of these says what to do next.
 */
export function EmptyState({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="flex flex-col items-start gap-1 px-4 py-8 text-sm">
      <p className="font-medium">{title}</p>
      <p className="max-w-prose text-muted-foreground">{children}</p>
    </div>
  );
}
